module.exports = __webpack_public_path__ + "assets/img/icon_vip_red.016b2fdf.png";